import * as React from "react";
import { SVGProps } from "react";

export const DocumentSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={42}
		height={42}
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect width={42} height={42} rx={6} fill="#0050FF" fillOpacity={0.08} />
		<path
			opacity={0.5}
			d="M31 22.8584V20.6564C31 18.0244 31 16.7074 30.23 15.8524C30.1594 15.7735 30.0846 15.6984 30.006 15.6274C29.151 14.8584 27.834 14.8584 25.202 14.8584H24.828C23.675 14.8584 23.098 14.8584 22.56 14.7054C22.2648 14.621 21.9802 14.5029 21.712 14.3534C21.224 14.0824 20.816 13.6734 20 12.8584L19.45 12.3084C19.176 12.0344 19.04 11.8984 18.896 11.7784C18.2767 11.265 17.5169 10.9503 16.716 10.8754C16.53 10.8584 16.336 10.8584 15.95 10.8584C15.067 10.8584 14.626 10.8584 14.258 10.9284C13.4678 11.0776 12.741 11.4615 12.1723 12.0301C11.6036 12.5986 11.2195 13.3253 11.07 14.1154C11 14.4844 11 14.9264 11 15.8084V22.8584C11 26.6294 11 28.5154 12.172 29.6864C13.343 30.8584 15.229 30.8584 19 30.8584H23C26.771 30.8584 28.657 30.8584 29.828 29.6864C31 28.5154 31 26.6294 31 22.8584Z"
			fill="#0050FF"
			fillOpacity={0.48}
		/>
		<path
			d="M23.4979 20.2986C23.6464 20.4306 23.7365 20.6162 23.7483 20.8146C23.7601 21.0129 23.6927 21.2079 23.5609 21.3566L20.8939 24.3566C20.8235 24.4357 20.7372 24.4991 20.6406 24.5425C20.544 24.5858 20.4393 24.6083 20.3334 24.6083C20.2275 24.6083 20.1228 24.5858 20.0262 24.5425C19.9296 24.4991 19.8433 24.4357 19.7729 24.3566L18.4389 22.8566C18.3068 22.7078 18.2393 22.5127 18.2511 22.3141C18.2629 22.1155 18.3531 21.9297 18.5019 21.7976C18.6507 21.6655 18.8459 21.598 19.0445 21.6098C19.2431 21.6216 19.4288 21.7118 19.5609 21.8606L20.3329 22.7306L22.4399 20.3606C22.5719 20.2121 22.7575 20.122 22.9559 20.1102C23.1542 20.0984 23.3492 20.1668 23.4979 20.2986Z"
			fill="#0050FF"
			fillOpacity={0.48}
		/>
	</svg>
);
